import medassistantLogo from './logo.svg';

export const Logo = ({ className }: { className?: string }) => {
  return (
    <img src={medassistantLogo} alt="Medassistant Logo" className={className} style={{ maxWidth: '150px' }} />
  );
};
